<template>
  <div>
    <h1 class="page-header">{{ $t('purchaseorder.purchaseorder') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-9">
            <ts-button color="info" outline @click="$router.push({ name: 'purchase-order-create' })">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-3 d-flex justify-content-end ts-space-x-2">
            <div class="ts-whitespace-no-wrap">
              <a-radio-group v-model="isRecevied" :default-value="undefined" button-style="solid" @change="fetchData()">
                <a-radio-button :value="undefined">
                  All
                </a-radio-button>
                <a-radio-button :value="1">
                  Received
                </a-radio-button>
                <a-radio-button :value="0">
                  Pendding
                </a-radio-button>
              </a-radio-group>
            </div>
            <ts-input v-model="search" :placeholder="$t('search')" class="ts-w-56" />
            <ts-button outline v-tooltip="$t('filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading" :rowGroup="{
          field: 'supplier_name'
        }">
          <template v-slot="{ record }">
            <td valign="middle" class="ts-whitespace-no-wrap">{{ record.branch_name_en }}</td>
            <td valign="middle" class="ts-whitespace-no-wrap">{{ record.po_date }}</td>
            <td valign="middle" class="ts-whitespace-no-wrap">{{ record.po_number }}</td>
            <td valign="middle" class="ts-whitespace-no-wrap ts-text-center">
              <span v-if="record.is_received"
                class="ts-bg-blue-100 ts-text-blue-500 ts-py-1 ts-px-2 ts-rounded-md">Received</span>
              <span v-else class="ts-bg-orange-100 ts-text-orange-500 ts-py-1 ts-px-2 ts-rounded-md">Pendding</span>
            </td>
            <td valign="middle" class="ts-whitespace-no-wrap ts-text-center">{{ sumQuantity(record).toLocaleString('en-IN') }}</td>
            <td valign="middle" class="ts-whitespace-no-wrap ts-text-right">$ {{ sumCost(record).toLocaleString('en-IN') }}</td>
            <td valign="middle" class="ts-whitespace-no-wrap ts-text-right"> {{ record.created_date }}</td>

            <td class="text-center ts-flex ts-space-x-2">
              <div
                class="ts-flex ts-items-center ts-justify-center ts-h-8 ts-w-8 ts-bg-red-100 ts-text-red-500 ts-rounded-full">
                <a href="#" v-tooltip="'PDF'" class="text-danger" @click.prevent="printPdf(record)">
                  <i class="fas fa-file-pdf"></i>
                </a>
              </div>
              <div
                class="ts-flex ts-items-center ts-justify-center ts-h-8 ts-w-8 ts-bg-blue-100 ts-text-blue-500 ts-rounded-full">
                <a href="#" v-tooltip="'Edit'" class="text-primary" @click.prevent="edit(record)">
                  <i class="fas fa-edit"></i>
                </a>
              </div>
              <div
                class="ts-flex ts-items-center ts-justify-center ts-h-8 ts-w-8 ts-bg-red-100 ts-text-red-500 ts-rounded-full">

                <a href="#" v-tooltip="'Delete'" class="text-danger" @click.prevent="destroy(record)"
                  :disabled="record._deleting">
                  <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                  <i class="fas fa-trash" v-else></i>
                </a>
              </div>
            </td>
          </template>
          <template #tfooter>
            <tr>
              <td colspan="4" class="ts-text-right">
                <strong>{{ $t('purchaseorder.total') }}</strong>
              </td>
              <td class="ts-text-center">
                <strong>{{ sumTotalQuantiy.toLocaleString('en-IN') }}</strong>
              </td>
              <td class="ts-text-right">
                <strong>$ {{ sumTotalCost.toLocaleString('en-IN') }}</strong>
              </td>
              <td></td>
            </tr>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer :title="$t('filter')" placement="right" :closable="false" :visible="visible"
      @close="() => (visible = false)" :zIndex="1020" width="300px">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <ts-branch-filter @filter="value => (branch_id = value)" />
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce, sumBy } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'purchase-order',
  data() {
    return {
      loading: false,
      visible: false,
      waiting: false,
      show_pdf: false,
      src: '',
      branch_id: []
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('purchaseOrder', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.purchaseOrder.search
      },
      set(newValue) {
        this.$store.commit('purchaseOrder/SET_SEARCH', newValue)
        this.$store.commit('purchaseOrder/RESET_CURRENT_PAGE')
      }
    },    
    isRecevied: {
      get() {
        return this.$store.state.purchaseOrder.is_received
      },
      set(newValue) {
        this.$store.commit('purchaseOrder/SET_IS_RECEIVED', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('purchaseorder.branch') },
        { name: this.$t('purchaseorder.date') },
        { name: this.$t('purchaseorder.ponumber') },
        { name: this.$t('purchaseorder.status'), style: 'text-align:center; width: 100px;' },
        { name: this.$t('purchaseorder.totalQty'), style: 'text-align:center; width: 100px;' },
        { name: this.$t('purchaseorder.totalCost'), style: 'text-align:right; width: 100px;' },
        { name: this.$t('purchaseorder.createdAt'), style: 'text-align:right; width: 100px;' },
        { name: this.$t('actions'), style: 'text-align:center; width: 7%;' }
      ]
    },
    sumTotalQuantiy() {
      return this.resources.reduce((carry, row) => {
        return carry + this.sumQuantity(row);
      }, 0)
    },
    sumTotalCost() {
      return this.resources.reduce((carry, row) => {
        return carry + this.sumCost(row);
      }, 0)
    },
    sumQuantity: () => row => {
      const details = row.purchase_order_details
      if (details !== undefined) {
        return sumBy(details, 'qty');
      }
      return 0;
    },
    sumCost: () => row => {
      const details = row.purchase_order_details
      if (details !== undefined) {
        return sumBy(details, 'cost');
      }
      return 0;
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'purchaseOrder/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('purchaseOrder/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'purchase-order-edit',
        params: { id: record.po_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('purchaseOrder/destroy', record.po_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    printPdf(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('purchaseOrder/printPdf', record.po_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'purchase-order-create') {
      this.$store.commit('purchaseOrder/RESET_STATE')
    }
    next()
  }
}
</script>
